<template>
  <span
    v-if="categoriesSelectedInSearch && !isAllCategoriesSelected"
    class="summary-bar-group"
  >
    <search-summary-bar-link-matches
      v-for="category in categoriesSelectedInSearch"
      :key="category.slug"
      :slug="slug"
      exclude-type="visibleMarker"
    >
      <pu-category-icons :categories="ensureArray(category)" />
    </search-summary-bar-link-matches>
  </span>
  <span v-else class="summary-bar-group">
    <search-summary-bar-link-matches
      id="summary-bar-all-categories"
      :slug="slug"
      exclude-type="visibleMarker"
      class="summary-bar-all-categories"
    >
      <img
        src="@/assets/images/category-icons/all-categories.svg"
        :alt="$t('Accommodation categories')"
        width="61"
        height="30"
      />
    </search-summary-bar-link-matches>
  </span>
</template>

<script lang="ts">
import { getCampsiteCategoriesPresenter } from '~/apps/categories/presenter-json/CampsiteCategoriesUpdaterJson'
import { SearchFilters } from '~/apps/search/schemas'
import CATEGORY_MAP from '~/json/catRoot.json'
import { ensureArray } from '~/utility/array'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { CampsiteCategory } from '~/utility/types/CampsiteCategory'

@Component
class SearchSummaryBarDetailsCategories extends Vue {
  @Prop()
  searchFilters: SearchFilters

  @Prop({ required: false })
  slug?: string

  ensureArray(ar) {
    return ensureArray(ar)
  }

  get categoriesSelectedInSearch(): CampsiteCategory[] | undefined {
    const searchCategories = this.searchFilters.categoryIds || []
    if (searchCategories.length) {
      const categoriesPresenter = getCampsiteCategoriesPresenter(
        this.$route.params.lang || 'en-gb',
      )
      return categoriesPresenter.list.filter((c) =>
        searchCategories.includes(c.id),
      )
    }
    return undefined
  }

  get isAllCategoriesSelected() {
    const categoryIds = Object.keys(CATEGORY_MAP)
    return this.categoriesSelectedInSearch
      ? this.categoriesSelectedInSearch.length === categoryIds.length
      : false
  }
}

export default toNative(SearchSummaryBarDetailsCategories)
</script>
<style scoped>
:deep(#summary-bar-all-categories) {
  align-items: center;
  display: flex;
  height: 100%;
  margin-right: 0.5em;
  background: none;
  border-radius: 0;
  padding: 0;
}

:deep(a.summary-bar-all-categories img) {
  height: 100%;
  filter: none;
}
</style>
